<template>
    <el-dialog
        :visible.sync="visible"
        :show-close="false"
        :width="width"
        :top="top"
        :append-to-body="appendToBody"
        :custom-class="classes"
        :close-on-click-modal="closeOnClickModal"
        :close-on-press-escape="false"
        :before-close="beforeClose">
        <div :class="`dialog-title ${titleClass}`" slot="title">
            <div class="title">
                <slot name="title">{{title}}</slot>
                <i @click="beforeClose" class="cmp-icon cmp-icon-close-btn close" v-if="showClose"></i>
            </div>
        </div>
        <div class="dialog-body">
            <slot></slot>
        </div>
        <slot name="footer"></slot>
    </el-dialog>
</template>

<script>
export default {
    name: 'CmpDialog',
    props: {
        visible: {
            default: false
        },
        showClose: {
            default: true
        },
        title: {
            default: ''
        },
        beforeClose: {
            default: () => {
                return () => {};
            }
        },
        width: {
            default: '700px'
        },
        customClasses: {
            default: ''
        },
        titleClass: {
            default: ''
        },
        appendToBody: {
            default: false
        },
        top: {
            default: '15vh'
        },
        closeOnClickModal: {
            default: false
        }
    },
    computed: {
        classes() {
            return this.customClasses + ' cmp-dialog';
        }
    }
};
</script>

<style lang="scss">
.cmp-dialog {
    box-shadow: -3px 10px 30px 0 rgba(0, 0, 0, .25);
    border-radius: 6px!important;
    .el-dialog__header {
        padding: 0;
        padding-left: 30px;
        font-size: 12px;
        background: #F8F8F8;
        border-radius: 6px;
        .dialog-title {
            position: relative;
            height: 45px;
            line-height: 45px;
            font-size: 13px;
            color: #000;
            font-weight: 700;
            .close {
                font-size: 15px;
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
            }
            .title {
                height: 100%;
                position: relative;
            }
        }

        .el-dialog__headerbtn {
            top: 16px;
        }
    }
    .el-dialog__body {
        padding: 0 16px;
        .modal-wrap {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
    }
    @keyframes scaling {
        0% {
            transform: scale(1)
        }
        50% {
            transform: scale(.85);
        }
        100% {
            transform: scale(1);
        }
    }
    .el-button {
            // width: 90px;
        width: 80px;
        height: 35px;
        line-height: 1px;
        // font-size: 14px;
        font-size: 13px;
        margin-left: 30px;
        font-weight: 700;
        &:first-of-type {
            margin-left: 0px;
        }
    }
    .el-button--default {
        border-color: $sub-font-color;
        color: $sub-font-color;
        background: none;
        &:hover {
            border-color: $theme-color;
            color: $theme-color;
            background: none;
        }
    }
    .el-button--primary {
        border-color: $theme-color;
        color: #fff;
        background: $theme-color;
        &:hover {
            color: #fff;
            background: $deep-theme-color;
            border-color: $deep-theme-color;
        }
    }
    // .el-button {
    //     width: 80px;
    //     height: 35px;
    //     line-height: 1px;
    //     font-size: 13px;
    //     margin-left: 30px;
    //     // padding: 10px 18px;
    //     // box-sizing: border-box;
    //     // border-radius: 17.5px;
    //     // font-size: 14px;
    //     // font-weight: 700;
    //     &--default {
    //         border: 1px solid #53575B;
    //         background-color: #fff;
    //         color: #53575B;
    //         &:hover, &:focus, &:active {
    //             border-color: transparent;
    //             background: rgba(83, 87, 91, .20);
    //         }
    //     }
    // }
}
</style>



// WEBPACK FOOTER //
// src/modules/cmp/components/CmpDialog.vue